import { apiBaseUrl } from '@/shared/env'
import {
  clearKitchenSession,
  getKitchenSession,
} from '@/shared/auth/sessionStorage'
import {
  clearDelmanSession,
  getDelmanSession,
} from '@/shared/auth/delmanSessionStorage'

const baseUrl = apiBaseUrl

function isDelmanApp(): boolean {
  return typeof window !== 'undefined' && window.location.pathname.startsWith('/delman')
}

export function getAccessToken(): string | null {
  if (typeof window === 'undefined') return null
  if (isDelmanApp()) {
    return getDelmanSession()?.accessToken ?? null
  }
  return getKitchenSession()?.accessToken ?? null
}

export function authHeader(): Record<string, string> {
  const token = getAccessToken()
  return token ? { Authorization: `Bearer ${token}` } : {}
}

/**
 * Token kedaluwarsa / tidak valid → bersihkan sesi sesuai konteks dan arahkan
 * ke halaman login yang tepat. Tidak dijalankan di server, saat sudah di halaman
 * login, atau untuk permintaan auth (mis. PIN salah saat login).
 */
function handleUnauthorized(): void {
  if (typeof window === 'undefined') return
  const path = window.location.pathname
  const onAuthPage = path.includes('/login') || path.includes('/activate')
  const isDelman = path.startsWith('/delman')

  if (isDelman) {
    clearDelmanSession()
    if (!onAuthPage) window.location.href = '/delman/login'
  } else {
    clearKitchenSession()
    if (!onAuthPage) window.location.href = '/kitchen/login'
  }
}

export async function apiFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${baseUrl}${path}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      ...init?.headers,
    },
  })

  if (!res.ok) {
    if (res.status === 401 && !path.startsWith('/auth')) {
      handleUnauthorized()
    }

    let message = `API ${res.status}: ${res.statusText}`
    try {
      const body = (await res.json()) as { error?: string }
      if (body.error) message = body.error
    } catch {
      // keep default message
    }
    throw new Error(message)
  }

  return res.json() as Promise<T>
}
